import React, { Fragment, memo } from 'react';
import Dialog from '@mui/material/Dialog';
import { Box, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { useLangFile } from 'js/context/LanguageContext';

interface ConfirmationDialogProps {
  title: string;
  content: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  onDelete: () => void;
  open: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  title,
  content,
  onCancel,
  onConfirm,
  onDelete,
  open,
}) => {
  const LangFile = useLangFile();

  return (
    <Fragment>
      <Dialog open={Boolean(open)} fullWidth maxWidth={'md'}>
        <DialogTitle>{title}</DialogTitle>

        <DialogContent style={{ overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              whiteSpace: 'pre-line',
            }}
          >
            <Box
              sx={{
                mb: 1,
              }}
            >
              {content}
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={onCancel} color={'inherit'} variant={'outlined'}>
            {LangFile.EditFieldConfirmationDialog.cancel}
          </Button>
          {onConfirm ? (
            <Button onClick={onConfirm} color={'primary'} variant={'contained'}>
              {LangFile.EditFieldConfirmationDialog.confirm}
            </Button>
          ) : (
            <Button onClick={onDelete} color={'secondary'} variant={'contained'}>
              {LangFile.EditFieldConfirmationDialog.delete}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(ConfirmationDialog);
